var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',[(_vm.isallow)?_c('v-progress-circular',{attrs:{"indeterminate":true,"color":"green","size":100}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.message))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }